// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterLabel-module__footerLabel___B9y26{display:inline-block;padding-right:16px}
`, "",{"version":3,"sources":["webpack://./node_modules/mintel-taskbar/node_modules/mintel-react-ui/dist/package/FooterLabel.css"],"names":[],"mappings":"AAAA,yCAAyC,oBAAoB,CAAC,kBAAkB","sourcesContent":[".FooterLabel-module__footerLabel___B9y26{display:inline-block;padding-right:16px}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
